const IMG_BASE = `/img/pre-class/cross-seller`

export const slides = [
    {
        title: 'who do you want to be? ',
        body:
            'Pick your hairstyle, your clothes and your look for Openhouse. Tell your friends who you are through your avatar.',
        cta: {
            text: 'pick avatar',
            link: `${process.env.REACT_APP_DASHBOARD_URL}/avatar`,
        },
        img: {
            src: `${IMG_BASE}/avatar.svg`,
            alt: 'Avatar',
        },
        bgColor: '#FFF6F4',
    },
    {
        title: 'what’s cookin’?',
        body:
            'Taylor Swift’s latest album is our favourite these days. What’s yours? Post your favourite shows, songs and movies on the oh.lobby.',
        cta: {
            text: 'start posting',
            link: `${process.env.REACT_APP_DASHBOARD_URL}#social`,
        },
        img: {
            src: `${IMG_BASE}/thoughtboard.svg`,
            alt: 'Thoughtboard',
        },
        bgColor: '#FFE9E9',
    },
    {
        title: 'get clubbin’',
        body:
            'Let the performer and problem solver in you shine. Unwind with extracurricular clubs for debate, dance, theatre, MUN, community service and entrepreneurship.',
        cta: {
            text: 'learn more',
            link: `${process.env.REACT_APP_WEBSITE_URL}/clubs`,
        },
        img: {
            src: `${IMG_BASE}/clubs.svg`,
            alt: 'Clubs',
        },
        bgColor: '#FBF4F9',
    },
    {
        title: 'a blog about you',
        body:
            'Exam stress. Open stories. Mental health. Octoberfest. The Openhouse blog is all about life at Openhouse. It’s all about you.',
        cta: {
            text: 'read more',
            link: `${process.env.REACT_APP_BLOGS_URL}`,
        },
        img: {
            src: `${IMG_BASE}/openroom.svg`,
            alt: 'Openroom',
        },
        bgColor: '#F1FFEE',
    },
    {
        title: 'revise with Openhouse',
        body:
            'Want to revise laws of reflection? Or brush up on integration? Take a 3-class mini-course on a particular topic to clear your doubts.',
        cta: {
            text: 'see mini courses',
            link: `${process.env.REACT_APP_WEBSITE_URL}/rescue-squad`,
        },
        img: {
            src: `${IMG_BASE}/mini-course.svg`,
            alt: 'Mini courses',
        },
        bgColor: '#FDFAF6',
    },
    {
        title: 'learn with friends',
        body: `studying alone can be boring. invite your friends at oh. to study with you! (p.s - you can gossip a little, but promise that you'll study for most of the time)`,
        cta: {
            text: 'coming soon',
            link: null,
        },
        img: {
            src: `${IMG_BASE}/group-study.svg`,
            alt: 'Group Study',
        },
        bgColor: '#DFE6FF',
    },
    {
        title: 'mocks for this exam season',
        body: `exams are scary enough in a normal year. this time, take the extra help from openhouse and prepare well with our mock tests for every subject.`,
        cta: {
            text: 'try a mock',
            link: `${process.env.REACT_APP_WEBSITE_URL}/mock-test`,
        },
        img: {
            src: `${IMG_BASE}/mock-test.svg`,
            alt: 'Mock Test',
        },
        bgColor: '#FAFAFA',
    },
]
